/**
 * Search Result info
 */
export class SearchResults {
    /**
     * Gets the length of search results.
     *
     * @aspType int
     * @returns {number} - Returns search results length.
     */
    get length() {
        return this.searchModule.textSearchResults.length;
    }
    /**
     * Gets the index of current search result.
     *
     * @aspType int
     * @returns {number} - Returns current search result index.
     */
    get index() {
        return this.searchModule.textSearchResults.currentIndex;
    }
    /**
     * Set the index of current search result.
     *
     * @param {number} value - Specifies the search result index.
     * @aspType int
     */
    set index(value) {
        if (this.length === 0 || value < 0 || value > this.searchModule.textSearchResults.length - 1) {
            return;
        }
        this.searchModule.textSearchResults.currentIndex = value;
        this.navigate();
    }
    constructor(search) {
        this.searchModule = search;
    }
    /**
     * Get start and end offset of searched text results.
     *
     * @returns {TextSearchResults[]} - Returns the text search results.
     */
    getTextSearchResultsOffset() {
        const index = [];
        let searchIndex;
        for (let i = 0; i < this.searchModule.textSearchResults.innerList.length; i++) {
            searchIndex = this.getOffset(this.searchModule.textSearchResults.innerList[parseInt(i.toString(), 10)]);
            index.push(searchIndex);
        }
        return index;
    }
    getOffset(innerList) {
        const start = innerList.start;
        const end = innerList.end;
        let blockInfo = this.searchModule.documentHelper.owner.selectionModule.getParagraphInfo(start);
        /* eslint-disable-next-line max-len */
        const startIndex = this.searchModule.documentHelper.owner.selectionModule.getHierarchicalIndex(blockInfo.paragraph, blockInfo.offset.toString());
        blockInfo = this.searchModule.documentHelper.owner.selectionModule.getParagraphInfo(end);
        /* eslint-disable-next-line max-len */
        const endIndex = this.searchModule.documentHelper.owner.selectionModule.getHierarchicalIndex(blockInfo.paragraph, blockInfo.offset.toString());
        return { 'startOffset': startIndex, 'endOffset': endIndex };
    }
    getModuleName() {
        return 'SearchResults';
    }
    /**
     * Replace text in current search result.
     *
     * @private
     * @param {string} textToReplace - text to replace
     * @returns {void}
     */
    replace(textToReplace) {
        if (this.index === -1) {
            return;
        }
        this.searchModule.replaceInternal(textToReplace);
    }
    /**
     * Replace all the instance of search result.
     *
     * @param {string} textToReplace text to replace
     * @returns {void}
     */
    replaceAll(textToReplace) {
        if (this.index === -1) {
            return;
        }
        this.searchModule.replaceAllInternal(textToReplace);
    }
    /**
     * @private
     * @returns {void}
     */
    navigate() {
        this.searchModule.navigate(this.searchModule.textSearchResults.currentSearchResult);
        this.searchModule.highlight(this.searchModule.textSearchResults);
    }
    /**
     * Clears all the instance of search result.
     *
     * @returns {void}
     */
    clear() {
        this.searchModule.textSearchResults.clearResults();
        this.searchModule.clearSearchHighlight();
        this.searchModule.viewer.renderVisiblePages();
    }
}
